import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sortable      from 'react-sortablejs' ;

import ContentsModal from 'contents_modal';

import S3Upload      from 's3_upload';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------

class DraftAdminEditMode extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal   : false,
      edit_id : null
    };
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  toggleEditMode(flg, edit_id) {
    this.setState({ modal: flg, edit_id: edit_id });
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  setMedia(url) {
    let data = this.props.data;
    let edit = this.props.edit;
    
    if( edit.media == undefined ) edit.media = {};
    if( edit.media[data.id] == undefined ) edit.media[data.id] = this.props.media;
    
    if( this.state.edit_id == null ){
      edit.media[data.id].push({ id: Utils.getUniqueID(), item_no: (edit.media[data.id].length + 1), media_url: url, is_original: true });
    } else {
      edit.media[data.id] = edit.media[data.id].map((d) => {
        if( d.id == this.state.edit_id ) d.media_url = url;
        return d;
      });
    }
    
    this.props.update_ev.bind(this)(edit);
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  deleteMedia(delete_id) {
    let edit = this.props.edit;
    
    let chk = confirm('メディアを削除しますか？');
    if( chk == false ) return;
    
    if( edit.delete_media == undefined ) edit.delete_media = [];
    edit.delete_media.push(delete_id);
    
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  setSubmissionMode() {
    let edit = this.props.edit;
    edit.submission_mode = true;
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  changeMedia(items) {
    let data = this.props.data;
    let edit = this.props.edit;
    if( edit.media == undefined ) edit.media = {};
    if( edit.media[data.id] == undefined ) edit.media[data.id] = this.props.media;
    
    let ary = [];
    items.map((id, key) => {
      edit.media[data.id].map((d) => {
        if( d.id == id ) ary.push(Object.assign(d, { item_no: (key + 1) }));
      });
    });
    
    edit.media[data.id] = ary.concat();
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  changeCaption(items) {
    let edit = this.props.edit;
    if( edit.caption == undefined ) edit.caption = {};
    
    edit.caption[this.props.data.id] = this.caption.value;
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  actionRepost(flg) {
    /*
    let edit = this.props.edit;
    if( edit.caption == undefined ) edit.caption = {};
    
    edit.caption[this.props.data.id] = this.caption.value;
    this.props.update_ev.bind(this)(edit);
    */
    let edit = this.props.edit;
    
    let repost = [];
    try { if( detail.repost != null ) repost = detail.repost.split(','); } catch(e) {}
    
    let data_id = String(this.props.data.id);
    if( flg == true ){
      if( repost.indexOf(data_id) == -1 ) repost.push(data_id);
    } else {
      repost = repost.filter((id) => { if( id != data_id ) return id; });
    }
    
    edit.repost = repost.concat();
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let media = this.props.media;
    let edit = this.props.edit;
    let detail = this.props.detail;
    let contents = this.props.contents;
    contents.id = data.id;
    
    let delete_media = edit.delete_media;
    if( delete_media == undefined ) delete_media = [];
    
    // キャプション
    let caption = null;
    try { if( contents.caption != undefined && contents.caption != null ) caption = contents.caption.replace(/\n|\r/ig, '<br />'); } catch(e) {}
    
    let set_contents_type = {};
    Const.value.contents_type_list.map((d) => { if( d.id == data.media_type ) set_contents_type = d; });
    
    // リポストリスト
    let repost = [];
    try { if( detail.repost != null ) repost = detail.repost.split(','); } catch(e) {}
    if( edit.repost != undefined ) repost = edit.repost;
    
    let is_repost = (repost.indexOf(String(contents.id)) >= 0 );
    
    let repost_button = (is_repost) ? <div className="button repost-button" onClick={this.actionRepost.bind(this, false)}>リポストを解除</div> : <div className="button repost-button" onClick={this.actionRepost.bind(this, true)}>リポストに設定</div>;
    if( is_repost ){
      return (
        <div className="none">リポスト投稿になります{repost_button}</div>
      );
    }
    
    return (
      <div className="draft-admin-edit-mode">
        <ul className="draft-contents-box">
          { (Object.keys(set_contents_type).length > 0 && set_contents_type.caption === true) &&
            <li className="caption-box">
              <p>本文・キャプション</p>
              
              <div className="contents-item-caption">
                <textarea className="caption" defaultValue={contents.caption} ref={(input) => { this.caption = input }} onChange={this.changeCaption.bind(this)} />
              </div>
              
            </li>
          }
        </ul>
        
        <h2 className="draft-contents-box-edit-title">メディア</h2>
        <Sortable options={{ group: 'shared', animation: 150 }} tag="ul" className="draft-contents-box-edit" onChange={this.changeMedia.bind(this)}>
          { media.map((d, key) => {
            if( delete_media.indexOf(d.id) >= 0 ) return null;
            
            return (
              <li key={key} data-id={d.id}>
                <p>{(key + 1)}枚目</p>
                
                <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>この画像・動画を削除する</Tooltip>}>
                  <i className="material-icons delete-button" onClick={this.deleteMedia.bind(this, d.id)}>close</i>
                </OverlayTrigger>
                
                <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>この画像・動画を変更する</Tooltip>}>
                  <i className="material-icons edit-button" onClick={this.toggleEditMode.bind(this, true, d.id)}>edit</i>
                </OverlayTrigger>
                
                <div className="contents-item-media">
                  { (!Utils.isVideo(d.media_url))
                    ? <div className="thumbnail"><img src={d.media_url} /></div>
                    : <div className="thumbnail"><video src={d.media_url} /></div>
                  }
                </div>
              </li>
            );
          })}
          
          {( media.length < 20) &&
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ここに画像・動画を追加する</Tooltip>}>
              <div className="add-button" onClick={this.toggleEditMode.bind(this, true, null)}>＋</div>
            </OverlayTrigger>
          }
        </Sortable>
        
        { (this.props.data.media_type == 'STORY') &&
          <div>{repost_button}</div>
        }
        
        { (detail.is_submission == 0 && edit.submission_mode == undefined)
          ? <div className="button is-submission-button" onClick={this.setSubmissionMode.bind(this)}><i className="material-icons">error_outline</i>「内容OK」できる状態にする</div>
          : <div className="button is-submission-button off"><i className="material-icons">done</i>「内容OK」できる状態にする</div>
        }
        
        <DraftAddMediaModal view={this.state.modal} set_ev={this.setMedia.bind(this)} close_ev={this.toggleEditMode.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class DraftAddMediaModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      upload_url : '',
    }
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let media = this.state.event.get_media.bind(this)();
    this.setState({ upload_url: media[0].url });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let event = this.state.event;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {350}
        height    = {250}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item add-draft-media-modal">
            
            <div className="upload-form">
              <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
              
              <label>
                <input type="file" name="example" size="30" onChange={(e) => { event.file_upload.bind(this)(e, 'draft/') }} />
                <span>ファイルを選択</span>
              </label>
            </div>
            
            { (this.state.upload_url != '') &&
              <div className="sample-media">
                { (!Utils.isVideo(this.state.upload_url))
                  ? <div className="thumbnail"><img src={this.state.upload_url} onError={(e)=>{e.target.src=this.state.upload_url}} /></div>
                  : <div className="thumbnail"><video src={this.state.upload_url} onError={(e)=>{e.target.src=this.state.upload_url}} /></div>
                }
              </div>
            }
            
            { (this.state.upload_url != '') &&
              <div className="button" onClick={this.props.set_ev.bind(this, this.state.upload_url)}>メディアを適用する</div>
            }
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftAdminEditMode;